// extracted by mini-css-extract-plugin
export default {"root":"styles_root__pbIAz","main":"styles_main__q0OX1"};